import { FC, ReactNode } from 'react';
import styles from './DrawingCollectionCard.module.scss';

export interface DrawingCollectionSublink {
  label: string;
  href?: string;
}

export interface DrawingCollectionCardProps {
  title: string;
  subtext: string;
  description: string;
  href?: string;
  icon?: ReactNode;
  sublinks?: DrawingCollectionSublink[];
  nonClickable?: boolean;
}

export const DrawingCollectionCard: FC<DrawingCollectionCardProps> = ({
  title,
  subtext,
  description,
  href = '/more-info',
  icon,
  sublinks,
  nonClickable = false,
}) => {
  const Component = nonClickable ? 'div' : 'a';

  return (
    <Component
      {...(!nonClickable ? { href } : {})}
      className={`${styles.card} ${nonClickable ? styles.nonClickable : ''}`}
    >
      <div className={styles.headerRow}>
        <div className={styles.iconWrapper} aria-hidden="true">
          {icon || '📁'}
        </div>
        <div className={styles.metaGroup}>
          <h3 className={styles.title}>{title}</h3>
          <span className={styles.subtext}>{subtext}</span>
        </div>
        {!nonClickable && (
          <span className={styles.arrow} aria-hidden="true">
            ↗
          </span>
        )}
      </div>
      <p className={styles.description}>{description}</p>
      {sublinks && sublinks.length > 0 && (
        <div className={styles.sublinksContainer}>
          {sublinks.map((link, idx) => (
            <a
              key={idx}
              href={link.href || '/more-info'}
              className={styles.chip}
              onClick={(e) => e.stopPropagation()}
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </Component>
  );
};
